#import '../fragments/activity-for-widget-fragment.graphql'

query GetActivitiesForWidget(
    $entityId: ID!
    $status: Int
    $activityTypes: [ID!]
    $sortOrder: SortOrder
) {
    activities(
        entityId: $entityId
        status: $status
        sortOrder: $sortOrder
        activityTypes: $activityTypes
    ) {
        ...ActivityForWidgetFragment
    }
}
